import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, intlShape, injectIntl } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { Modal } from '../..';

import css from './TransactionsModal.css';
import { NamedLink } from '../../../components';

const TransactionsModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    completedTxs,
    ongoingTxs,
    futureTxs,
    overdueTxs,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Stan aktywnego taba
  const [activeTab, setActiveTab] = useState('overdue');

  // Mapowanie typów do danych
  const transactionData = {
    overdue: overdueTxs,
    ongoing: ongoingTxs,
    future: futureTxs,
    completed: completedTxs,
  };

  const transactions = transactionData[activeTab] || [];

  const tabs = ['overdue', 'ongoing', 'future', 'completed'];

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={' '}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="TransactionsModal.title" />
      </p>

      {/* Taby */}
      <div className={css.tabs}>
        {tabs.map(tab => (
          <button
            key={tab}
            className={classNames(css.tab, { [css.activeTab]: activeTab === tab })}
            onClick={() => setActiveTab(tab)}
          >
            <FormattedMessage id={`TransactionsModal.tab.${tab}`} defaultMessage={tab} />
          </button>
        ))}
      </div>

      {/* Lista transakcji */}
      <div className={css.transactionList}>
        {transactions.map(tx => (
          <div key={tx.id.uuid} className={css.transaction}>
            <div className={css.transactionHeader}>
              <div>
                <NamedLink
                  name="SalePage"
                  params={{ id: tx.id.uuid }}
                  className={css.code}
                >
                  {tx.attributes.code}
                </NamedLink>
                <span>{tx.attributes.processState}</span>
              </div>
              <span>{tx.attributes.start} - {tx.attributes.end}</span>
            </div>
            <div className={css.listings}>
              {tx.listings.map(l => (
                <div key={l.id.uuid}>{l.attributes.title}</div>
              ))}
            </div>
            <div>{tx.provider.attributes.name}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

const { bool, string } = PropTypes;

TransactionsModal.defaultProps = {
  className: null,
  rootClassName: null,
  reviewSent: false,
  sendReviewInProgress: false,
  sendReviewError: null,
};

TransactionsModal.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  reviewSent: bool,
  sendReviewInProgress: bool,
  sendReviewError: propTypes.error,
  completedTxs: PropTypes.array.isRequired,
  ongoingTxs: PropTypes.array.isRequired,
  futureTxs: PropTypes.array.isRequired,
  overdueTxs: PropTypes.array.isRequired,
};

export default injectIntl(TransactionsModal);
